import Compare from './components/Compare';

export const compare = {
  firstLevel: Compare,
};